import React from 'react';
import { connect } from 'react-redux';
import { getMessage } from 'util/locale';
import propTypes from 'prop-types';
import { replace } from 'react-router-redux';

import { getScriptById } from 'scripts/selectors';
import { getEntryPath, getRouteVersion } from 'settings/selectors';
import { isEditRoute } from 'routes/selectors';
import { isInitialLoadDone as isInitialLoadDoneFunc } from 'api/loading/selectors';
import { getEditRouteForScriptId, getManageRouteForUserIdFieldIdScriptId } from 'util/routes';
import FatalError from 'common/FatalError';

let RedirectToDefaultContainer = ({
  dispatch,
  editRoute,
  scriptIdIsValid,
  fatalError,
  isAppMode,
  isEditRoute,
  isInitialLoadDone,
  manageRoute
}) => {
  let redirectRoute;
  if (isAppMode) {
    redirectRoute = editRoute;
  } else {
    redirectRoute = (isEditRoute && scriptIdIsValid) ? editRoute : manageRoute;
  }

  // Handles error for no fields
  if (fatalError) {
    return <FatalError error={fatalError}/>;
  }

  if (isInitialLoadDone && redirectRoute) {
    // Below does not want to be called during render(), so we tell it to run once it's done
    setTimeout( () => dispatch(replace(redirectRoute)), 0);
  }
  return (<div>{ getMessage('text__in-progress--redirect-default-prescription') }</div>);
};
RedirectToDefaultContainer.propTypes = {
  dispatch: propTypes.func.isRequired,
  editRoute: propTypes.string.isRequired,
  fatalError: propTypes.object,
  isAppMode: propTypes.bool.isRequired,
  isEditRoute: propTypes.bool.isRequired,
  isInitialLoadDone: propTypes.bool,
  manageRoute: propTypes.string.isRequired,
  scriptIdIsValid: propTypes.bool.isRequired
};
export default connect(
  (state) => {
    const { fieldId, scriptId, userId } = state.current;
    const script = getScriptById(state, scriptId);

    return {
      editRoute: getEditRouteForScriptId(state, scriptId),
      fatalError: state.current.fatalError,
      getRouteVersion: getRouteVersion(state),
      isEditRoute: isEditRoute(getEntryPath(state)),
      isAppMode: state.settings.isAppMode,
      isInitialLoadDone: isInitialLoadDoneFunc(state),
      manageRoute: getManageRouteForUserIdFieldIdScriptId({ state, userId, fieldId }),
      scriptIdIsValid: !!script
    };
  }
)(RedirectToDefaultContainer);
